/**
 * Constants shared between the pdfjsAssets Vite plugin (Node) and browser code.
 * Kept free of Node imports so components can reference them without pulling in the plugin.
 */

/** Public path under which the plugin serves pdf.js runtime assets. */
export const PDFJS_ASSET_BASE = '/pdfjs-assets/';

/**
 * Worker path. pdf.js ships the worker as `.mjs`, which nginx's mime.types does not know:
 * it would be served as application/octet-stream, which browsers refuse for a module
 * worker and which Traefik's compression allowlist skips. The plugin copies it out under
 * a `.js` name instead of letting Vite emit the original extension.
 */
export const PDFJS_WORKER_PATH = `${PDFJS_ASSET_BASE}pdf.worker.js`;

/**
 * Class the plugin rewrites pdf.js's `:root` selectors to. Put it on the viewer's
 * root element so the stylesheet's variables — and its `color-scheme` — stay inside
 * the component instead of applying to the whole document.
 */
export const PDFJS_SCOPE_CLASS = 'medcom-pdf-viewer';
